module.exports = __webpack_public_path__ + "static/media/pompy2.658bbce8.svg";